export default __webpack_public_path__ + "static/media/gaps.59d4a954.png";